export default __webpack_public_path__ + "static/media/Variabilitadel-icon.77f25cd1.svg";